import React from 'react';

interface PremiumLoaderProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
}

const PremiumLoader: React.FC<PremiumLoaderProps> = ({ 
  text = 'Loading...', 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div 
        className={`${sizeClasses[size]} rounded-full bg-lime animate-pulse`}
        style={{ 
          boxShadow: '0 0 20px rgba(207, 239, 0, 0.4)',
          animation: 'pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite'
        }}
      />
      {text && (
        <p className={`${textSizeClasses[size]} font-medium text-foreground/80`}>
          {text}
        </p>
      )}
    </div>
  );
};

export default PremiumLoader;
